// ============================================================
// Portfolio Module - Project Cards Interactivity
// ============================================================

import Swal from 'sweetalert2';
import { getLocale, t } from './i18n.js';

export function initPortfolioCards() {
    const projectButtons = document.querySelectorAll('.project-btn');

    projectButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            const projectName = button.getAttribute('data-project');

            // Only prevent default and show modal if it has data-project attribute
            // Let real links (with href and no data-project) work normally
            if (projectName) {
                e.preventDefault();

                const card = button.closest('.project-card');
                const projectTitle = card.querySelector('.project-title').textContent;

                // Trigger hover effect
                card.style.animation = 'pulse 0.3s ease-out';

                // Show SweetAlert modal
                showProjectModal(projectName, projectTitle);
            }
        });

        // Add hover effect
        button.addEventListener('mouseenter', () => {
            button.style.transform = 'scale(1.05)';
        });

        button.addEventListener('mouseleave', () => {
            button.style.transform = 'scale(1)';
        });
    });

    // ============================================================
    // Project Modal Details
    // ============================================================
    const projectDetails = {
        'e-commerce': {
            key: 'portfolio.modal.projects.ecommerce',
            tech: ['React', 'Node.js', 'MongoDB', 'Redux', 'Stripe API', 'Bootstrap'],
            github: '#',
            live: '#',
        },
        analytics: {
            key: 'portfolio.modal.projects.analytics',
            tech: ['Vue.js', 'D3.js', 'Vuex', 'REST API', 'Chart.js', 'Bootstrap'],
            github: '#',
            live: '#',
        },
        tasks: {
            key: 'portfolio.modal.projects.tasks',
            tech: ['JavaScript', 'Firebase', 'Bootstrap', 'HTML5', 'CSS3', 'Firestore'],
            github: '#',
            live: '#',
        },
    };

    function showProjectModal(projectKey, fallbackTitle) {
        const details = projectDetails[projectKey] || {};
        const isRtl = getLocale() === 'ar';
        const align = isRtl ? 'right' : 'left';

        const baseKey = details.key;
        const localizedTitle = baseKey ? t(`${baseKey}.title`) : '';
        const localizedDescription = baseKey ? t(`${baseKey}.description`) : '';
        const localizedFeatures = baseKey ? t(`${baseKey}.features`) : [];

        const title = localizedTitle && localizedTitle !== `${baseKey}.title`
            ? localizedTitle
            : fallbackTitle;
        const description = localizedDescription && localizedDescription !== `${baseKey}.description`
            ? localizedDescription
            : t('portfolio.modal.fallbackDescription');
        const features = Array.isArray(localizedFeatures) ? localizedFeatures : [];

        const featuresList = features
            .map(f => `<li style="text-align: ${align}; color: #94A3B8;">✓ ${f}</li>`)
            .join('');

        const techBadges = (details.tech || [])
            .map(t => `<span style="display: inline-block; background: rgba(255, 184, 0, 0.2); color: #FFB800; padding: 4px 10px; border-radius: 20px; margin: 4px 4px; font-size: 12px; border: 1px solid rgba(255, 184, 0, 0.3);">${t}</span>`)
            .join('');

        const htmlContent = `
            <div style="text-align: ${align}; color: #94A3B8;">
                <h2 style="color: #E2E8F0; margin-bottom: 16px;">${title}</h2>
                <p style="margin-bottom: 20px; font-size: 14px;">${description}</p>

                <h4 style="color: #E2E8F0; margin-bottom: 10px; margin-top: 20px;">${t('portfolio.modal.featuresTitle')}</h4>
                <ul style="list-style: none; padding: 0; margin-bottom: 20px;">
                    ${featuresList}
                </ul>

                <h4 style="color: #E2E8F0; margin-bottom: 10px;">${t('portfolio.modal.techTitle')}</h4>
                <div style="margin-bottom: 20px;">
                    ${techBadges}
                </div>
            </div>
        `;

        Swal.fire({
            title,
            html: htmlContent,
            icon: 'info',
            background: '#1E293B',
            color: '#94A3B8',
            confirmButtonColor: '#FFB800',
            confirmButtonText: t('portfolio.modal.close'),
            customClass: {
                popup: 'code-dragon-swal',
                title: 'swal-title',
                htmlContainer: 'swal-content',
            },
            didOpen: (modal) => {
                modal.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
                // Add custom styling to modal
                modal.style.borderRadius = '12px';
                modal.style.border = '1px solid rgba(255, 184, 0, 0.2)';
                modal.style.boxShadow = '0 0 30px rgba(255, 184, 0, 0.1)';
            },
        });
    }
}
